import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ActionsService, UserService } from '@app/core/services';
import { HowdenAuthService, HowdenLogService, HowdenSecurityService, IAuthenticationTicketDto } from '@howdeniberia/core-front';

@Component({
  selector: 'howden-granted',
  templateUrl: './granted.component.html',
  styleUrls: ['./granted.component.scss']
})
export class GrantedComponent implements OnInit {
  private router = inject(Router);
  private userSrv = inject(UserService);
  private actionSrv = inject(ActionsService);
  private howdenSecuritySrv = inject(HowdenSecurityService);
  private authSrv = inject(HowdenAuthService);
  private logSrv = inject(HowdenLogService);

  ngOnInit(): void {
    if (this.userSrv.actualDataValidAD()) {
      // Ensure the Howden authentication service has the latest data
      this.authSrv.reload();
      // This will try to make a request to the Security Backend
      const callback = this.userSrv.appData.callback;
      this.howdenSecuritySrv.getIdentityToken(callback).subscribe({
        next: (res: IAuthenticationTicketDto) => {
          this.actionSrv.hideLoading();
          if (res.accessApps?.length === 0 && !res.isSuperAdmin) {
            this.logSrv.Log('token obtenido pero sin acceso a ninguna App', res);
            this.router.navigateByUrl('forbidden');
          } else {
            this.userSrv.saveIdentificationResult(res);
            this.router.navigateByUrl('preferences');
          }
        },
        error: (err: any) => {
          this.logSrv.Log('GrantedComponent - Error obteniendo token', err);
          this.actionSrv.hideLoading();
          this.router.navigateByUrl('forbidden');
        }
      });
    }
  }
}
